import { Observable } from "rxjs";
import { OrderContainer } from "../model/order-container";

export abstract class OrderPackagingContainerService {
    public abstract getOrderPackagingContainer(packagingContainerId: string, initialReset: boolean): Observable<OrderContainer | undefined>;
    public abstract resetCache(): void;
}